import dayjs from 'dayjs';
export default {
  name: 'video_sel',
  props: {
    labId: {
      type: String,
      default: ''
    },
    areaId: {
      type: String,
      default: ''
    },
    searchKey: {
      type: String,
      default: ''
    },
    state: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      pageConfig: {
        queryFunName: 'planQuery'
      },
      dayjs: dayjs,
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: this.searchKey || null,
        state: this.state || null,
        sortField: '^state,expect_stocking_date,batch_code',
        labId: this.labId || null,
        areaId: this.areaId || null
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      state: {
        'A_Plan': '计划',
        'Active': '养殖中',
        'Completed': '养殖结束',
        'Discarded': '废弃'
      }
    };
  },
  mounted: function mounted() {
    this.query();
  },
  methods: {
    sel: function sel(data) {
      this.$emit('child-plan-sel', data);
    },
    query: function query() {
      var _this = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this.tableData = res.data || [];
        _this.totalCount = res.count;
        _this.queryLoading = false;
      });
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : '^state,expect_stocking_date,batch_code';
      this.query();
    }
  }
};